export default __webpack_public_path__ + "static/media/flag-gabon.1dc0d84b.svg";